// 모바일 디바이스 감지 유틸리티

/**
 * User Agent를 기반으로 모바일 디바이스인지 확인하는 함수
 * @returns {boolean} 모바일 디바이스 여부
 */
export const isMobileUserAgent = (): boolean => {
  if (typeof window === 'undefined') return false;
  
  const userAgent = window.navigator.userAgent.toLowerCase();
  const mobileKeywords = [
    'mobile', 'android', 'iphone', 'ipad', 'ipod', 
    'blackberry', 'windows phone', 'opera mini'
  ];
  
  return mobileKeywords.some(keyword => userAgent.includes(keyword));
};

/**
 * 화면 크기를 기반으로 모바일 디바이스인지 확인하는 함수
 * @returns {boolean} 모바일 화면 크기 여부
 */
export const isMobileScreenSize = (): boolean => {
  if (typeof window === 'undefined') return false;
  
  // 768px 이하를 모바일로 간주
  return window.innerWidth <= 768;
};

/**
 * 터치 지원 여부를 확인하는 함수
 * @returns {boolean} 터치 지원 여부
 */
export const isTouchDevice = (): boolean => {
  if (typeof window === 'undefined') return false;
  
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
};

/**
 * 종합적으로 모바일 디바이스인지 확인하는 함수
 * User Agent, 화면 크기, 터치 지원을 모두 고려
 * @returns {boolean} 모바일 디바이스 여부
 */
export const isMobileDevice = (): boolean => {
  // User Agent 기반 검사가 가장 확실하므로 우선 적용
  if (isMobileUserAgent()) return true;
  
  // User Agent로 감지되지 않은 경우 화면 크기와 터치 지원 여부로 판단
  return isMobileScreenSize() && isTouchDevice();
};

/**
 * 화면 크기 변화를 감지하여 모바일 여부를 실시간으로 확인하는 함수
 * @param callback 모바일 상태 변화 시 호출될 콜백 함수
 * @returns cleanup 함수
 */
export const watchMobileDevice = (callback: (isMobile: boolean) => void): (() => void) => {
  if (typeof window === 'undefined') return () => {};
  
  const handleResize = () => {
    callback(isMobileDevice());
  };
  
  // 초기 상태 확인
  handleResize();
  
  // 리사이즈 이벤트 리스너 등록
  window.addEventListener('resize', handleResize);
  
  // cleanup 함수 반환
  return () => {
    window.removeEventListener('resize', handleResize);
  };
}; 